import queryString from "query-string";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { BaseRepository } from "../Base/base.repository";
import { CreateHomeConfigDto } from "./dto/create.dto";
import { UpdateHomeConfigDto } from "./dto/update.dto";
import { DeleteHomeConfigDto } from "./dto/delete.dto";
import { GetHomeConfigDto } from "./dto/get.dto";
import { HomeConfigRepositoryInterface } from "./homeConfig";

export class HomeConfigRepository
  extends BaseRepository<GetHomeConfigDto>
  implements HomeConfigRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: ServerlessConfigure.ApiEndpoint,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async getList() {
    const response = await this.apiRequest.getList({
      url: "/homes/configs",
    });

    return response.data.Items;
  }

  async create(homeId: string, dto: CreateHomeConfigDto) {
    const { homeName, configLink, region, community, userId } = dto;

    const data: Record<string, string> = { homeName, configLink };
    if (region) {
      data.region = region;
    }
    if (community) {
      data.community = community;
    }
    if (userId) {
      data.userId = userId;
    }

    await this.apiRequest.post<void>({
      url: `/homes/${homeId}/config`,
      data,
    });
  }

  async update(homeId: string, dto: UpdateHomeConfigDto) {
    const { configLink, region, community, userId } = dto;

    const data: Record<string, string> = { configLink };
    if (region) {
      data.region = region;
    }
    if (community) {
      data.community = community;
    }
    if (userId) {
      data.userId = userId;
    }

    await this.apiRequest.put<void>({
      url: `/homes/${homeId}/config`,
      data,
    });
  }

  async delete(homeId: string, dto: DeleteHomeConfigDto) {
    const { region, community, userId } = dto;

    const query = queryString.stringify(
      { region, community, userId },
      { skipEmptyString: true },
    );

    await this.apiRequest.delete({
      url: `/homes/${homeId}/config?${query}`,
    });
  }
}
